import { render, staticRenderFns } from "./FlipBookAddToCartBtn.vue?vue&type=template&id=208ac321&scoped=true"
import script from "./FlipBookAddToCartBtn.vue?vue&type=script&lang=js"
export * from "./FlipBookAddToCartBtn.vue?vue&type=script&lang=js"
import style0 from "./FlipBookAddToCartBtn.vue?vue&type=style&index=0&id=208ac321&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208ac321",
  null
  
)

export default component.exports